import React, { PropTypes } from 'react';
import mediator, { ACTIONS } from 'mediator';
import classnames from 'classnames';
import metrics from 'lib/common/metrics';

const LevelSelector = React.createClass({
  propTypes: {
    levels: PropTypes.arrayOf(PropTypes.object),
    selectedLevel: PropTypes.object,
    isAvailable: PropTypes.bool // eslint-disable-line react/no-unused-prop-types
  },
  getInitialState: function() {
    return {
      selectedLevel: this.props.selectedLevel
        ? this.props.selectedLevel.selector
        : null
    };
  },
  componentDidMount: function() {
    mediator.subscribe(ACTIONS.LEVEL_PRESELECTED, level => {
      this.setState({ selectedLevel: level });
    });
  },
  componentDidUpdate: function(prevProps, prevState) {
    let selectedLevel = this.state.selectedLevel;
    if (prevState.selectedLevel !== selectedLevel) {
      mediator.publish(ACTIONS.LEVEL_SELECTED, selectedLevel);
    }
  },
  onReset: function() {
    metrics.action('Selected section', 'All sections');
    this.setState({ selectedLevel: null });
  },
  onChange: function(e) {
    let val = e.currentTarget.value;
    if (val) {
      metrics.action('Selected level', val);
      this.setState({
        selectedLevel: val
      });
    }
  },
  render: function() {
    return (
      <div className="syos-key syos-key--optional">
        <ul className="syos-key__list">
          <li className="syos-key__list__item">
            <input
              className="syos-key__option-input"
              type="radio"
              name="radio-level"
              id="radio-level-any"
              value=""
              checked={this.state.selectedLevel === null ? true : false}
              onChange={this.onReset}
              aria-label="All levels"
            />
            <label className="syos-key__option-label" htmlFor="radio-level-any">
              All sections
            </label>
          </li>
          {this.props.levels.map((level, idx) => {
            return (
              <li className="syos-key__list__item" key={idx}>
                <label
                  className={classnames({
                    'syos-key__option-label': true,
                    'syos-key__option-label--disabled': !level.isAvailable
                  })}
                >
                  <input
                    type="radio"
                    className="syos-key__option-input"
                    onChange={this.onChange}
                    name="radio-level"
                    id={`radio-level-${idx}`}
                    value={level.el.id}
                    disabled={!level.isAvailable}
                    checked={this.state.selectedLevel === level.el.id}
                  />
                  {level.label}
                </label>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
});

export default LevelSelector;



// WEBPACK FOOTER //
// ./src/javascripts/app/components/LevelSelector.js